import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Product from "./pages/Product";
import Features from "./pages/Features";
import About from "./pages/About";
import Contact from "./pages/Contact";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import DataSources from "./pages/DataSources";
import SemanticGraph from "./pages/SemanticGraph";
import Glossary from "./pages/Glossary";
import SchemaProfiler from "./pages/SchemaProfiler";
import Chat from "./pages/Chat";
import Signals from "./pages/Signals";
import SavedQueries from "./pages/SavedQueries";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-[#0a0a1a]">
          <Navbar />
          <Routes>
            <Route path="/" element={<><Landing /><Footer /></>} />
            <Route path="/product" element={<><Product /><Footer /></>} />
            <Route path="/features" element={<><Features /><Footer /></>} />
            <Route path="/about" element={<><About /><Footer /></>} />
            <Route path="/contact" element={<><Contact /><Footer /></>} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/app/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/app/admin-dashboard" element={
              <ProtectedRoute><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/app/data-sources" element={
              <ProtectedRoute><DataSources /></ProtectedRoute>
            } />
            <Route path="/app/data-sources/:id/profile" element={
              <ProtectedRoute><SchemaProfiler /></ProtectedRoute>
            } />
            <Route path="/app/semantic-graph" element={
              <ProtectedRoute><SemanticGraph /></ProtectedRoute>
            } />
            <Route path="/app/glossary" element={
              <ProtectedRoute><Glossary /></ProtectedRoute>
            } />
            <Route path="/app/chat" element={
              <ProtectedRoute><Chat /></ProtectedRoute>
            } />
            <Route path="/app/signals" element={
              <ProtectedRoute><Signals /></ProtectedRoute>
            } />
            <Route path="/app/saved-queries" element={
              <ProtectedRoute><SavedQueries /></ProtectedRoute>
            } />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
